<template>
  <div class="baby_manage_tabs">
    <goods-logistics-setup v-if="type === 'goodsLogistics'" @tabschange="tabschange"></goods-logistics-setup>
    <general-logistics-setup v-if="type === 'generalLogistics'" @tabschange="tabschange"></general-logistics-setup>
  </div>
</template>

<script>
  import GoodsLogisticsSetup from './goods-logistics-setup';
  import GeneralLogisticsSetup from './general-logistics-setup';

  export default {
    name: 'default-delivery-logistics',
    components: {GoodsLogisticsSetup, GeneralLogisticsSetup},
    data() {
      return {
        type: 'goodsLogistics' // 显示类型  goodsLogistics = 货品物流设置  generalLogistics = 通用物流设置
      }
    },
    methods: {
      // tabs切换路由跳转
      tabschange(e) {
        // console.log(e);
        this.type = e.type;
        this.$router.push({
          path: '/home/d_logistics',
          query: {
            type: this.type
          }
        });
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .baby_manage_tabs {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/default-delivery-logistics/default-delivery-logistics.vue